import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { selectApiStatus } from "../../redux/slices/apiStatusSlice";
import { selectFullJobFetchLoading, selectFullJobFetchSyncing } from "../../redux/slices/fullJobFetchSlice";

const FetchStatus = () => {
  const apiStatus = useSelector(selectApiStatus);
  const fullJobLoading = useSelector(selectFullJobFetchLoading);
  const fullJobSyncing = useSelector(selectFullJobFetchSyncing);
  const [showModal, setShowModal] = useState(false);

  // Check if all APIs are successful AND fullJobFetch is not loading/syncing
  const allSuccess =
    !fullJobLoading && 
    !fullJobSyncing &&
    apiStatus && 
    Object.keys(apiStatus).length > 0 &&
    Object.values(apiStatus).every((status) => status === "success");

  const handleIconClick = () => {
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  return (
    <>
      <i
        className={`fetch-status-trigger bi ${
          allSuccess ? "fetch-status-success bi-check-circle" : "bi-exclamation-circle"
        }`}
        style={{ cursor: "pointer", color: allSuccess ? "green" : "red" }}
        onClick={handleIconClick}
        onKeyDown={(event) => {
          if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            handleIconClick();
          }
        }}
        role="button"
        tabIndex={0}
        aria-label="View API status"
      ></i>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>API Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Show fullJobFetch status */}
          <div className="mb-3">
            <strong>Full Job Fetch:</strong>{" "}
            <span style={{ color: fullJobLoading ? "orange" : "green" }}>
              {fullJobLoading ? "Loading..." : "Complete"}
            </span>
            {fullJobSyncing && (
              <span style={{ color: "blue", marginLeft: "10px" }}>
                (Syncing...)
              </span>
            )}
          </div>
          
          <hr />
          
          {/* Show individual API statuses */}
          <strong>Section API Status:</strong>
          {apiStatus && typeof apiStatus === 'object' && Object.keys(apiStatus).length > 0 ? (
            <ul>
              {Object.entries(apiStatus).map(([key, value]) => (
                <li key={key} style={value !== "success" ? { color: value === "pending" ? "orange" : "red", fontWeight: "bold" } : {}}>
                  {key}: {value || "Missing status"}
                </li>
              ))}
            </ul>
          ) : (
            <p>No API status available.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FetchStatus;
